// Same variable names as the other Metafor frontends, so their .env can be reused.
export const env = {
  // the customer app that "Sign in as" opens
  customerAppUrl: (import.meta.env.REACT_APP_CUSTOMER_APP_URL as string | undefined) ?? 'http://localhost:5175',
  apiBaseUrl: import.meta.env.REACT_APP_API_BASE_URL as string,
  firebase: {
    apiKey: import.meta.env.REACT_APP_FIREBASE_API_KEY as string,
    authDomain: import.meta.env.REACT_APP_AUTH_DOMAIN as string,
    projectId: import.meta.env.REACT_APP_PROJECT_ID as string,
    storageBucket: import.meta.env.REACT_APP_STORAGE_BUCKET as string,
    messagingSenderId: import.meta.env.REACT_APP_MESSAGING_SENDER_ID as string,
    appId: import.meta.env.REACT_APP_APP_ID as string,
  },
}
